function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { crudProfilingScore } from '@/mixins/profiling.js';
import ProfilingTableParameters from '@/components/profiling/ProfilingTableParameters';
export default {
  name: 'ValidationType',
  components: {
    ProfilingTableParameters: ProfilingTableParameters
  },
  mixins: [crudProfilingScore],
  data: function data() {
    return {
      modalName: 'validation Type',
      modalId: 'ProfilingValidationType',
      dispatchName: 'getProfilingValidationType',
      domainIsItc: false,
      filter_enabled: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['isDomainItc', 'select_profiling_validation_type'])), {}, {
    fields: function fields() {
      return [{
        value: 'name',
        text: this.traductor('data_quality.tablas.name'),
        sortable: true
      }, {
        value: 'weight',
        text: this.traductor('data_quality.tablas.weight'),
        align: "center"
      }, {
        value: 'actions',
        text: this.traductor('data_quality.tablas.actions'),
        align: "center"
      }];
    },
    fields_sf: function fields_sf() {
      return [{
        key: 'field_type',
        label: this.traductor('tablas.field_type'),
        sortable: true,
        class: 'text-left pl-3'
      }, {
        key: 'weight',
        label: this.traductor('tablas.weight'),
        align: "center"
      }, {
        key: 'actions',
        label: this.traductor('tablas.actions'),
        align: "center"
      }];
    },
    fields_st: function fields_st() {
      return [{
        key: 'table_rule',
        label: this.traductor('tablas.table_type'),
        sortable: true,
        class: 'text-left pl-3'
      }, {
        key: 'lower',
        label: this.traductor('tablas.lower'),
        align: "center"
      }, {
        key: 'upper',
        label: this.traductor('tablas.upper'),
        align: "center"
      }, {
        key: 'actions',
        label: this.traductor('tablas.actions'),
        align: "center"
      }];
    },
    rows: function rows() {
      return this.select_profiling_validation_type.length;
    }
  }),
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getRecords: function getRecords() {
      var _this = this;
      if (!this.select_profiling_validation_type.length) {
        this.toggleBusy();
        this.$store.dispatch('data-platform/' + this.dispatchName).then(function () {
          _this.toggleBusy();
        });
      }
    },
    formatter: function formatter(value) {
      return value.toLowerCase();
    }
  }
};